import * as types from "./types";
import { initialState } from "./initialState";

export default function limitReducer(state = initialState, action) {
  switch (action.type) {
    
    case types.API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case types.GET_UOP:
      return {
        ...state,
        uoplist: action.payload,
      };

    case types.UPDATE_UOP:
      return {
        ...state,
        updateuop: action.payload,
      };

    case types.DELETE_UOP:
      return {
        ...state,
        deleteuop: action.payload,
      };

    case types.ADD_UOP:
      return {
        ...state,
        adduop: action.payload,
      };

    case types.META_LIST:
      return {
        ...state,
        metalist: action.payload,
      };

    case types.APPROVE_UOP:
      return {
        ...state,
        approving: action.payload,
      };

    default:
      return state;
  }
}
